import Tooltip from './Tooltip';
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tooltip@4.0.3@rc-tooltip/es/index.js
// module id = 2299
// module chunks = 0